import TopNavBar from "./TopNavBar";
import { useState } from "react";
import { useEffect } from "react";
import { projectURL } from "./utils/mockdata";

const UpcomingBday = (props) => {
    const [upcomingBday, setUpcomingBday] = useState([]);
    const loggedUserId = sessionStorage.getItem("loggedUserId");

    useEffect(() => {
        const fetchUpcomingBday = async () => {
            const response = await fetch(projectURL + "profiles/my-friends-upcoming-birthdays/" + loggedUserId);
            const data = await response.json();
            setUpcomingBday(data.users);
        };
        fetchUpcomingBday();
    }, [loggedUserId]);

    return (
        <div className="min-h-full">
            <TopNavBar />
            <main>
                <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
                    <div className="text-center">
                        <h1 className="text-3xl font-bold text-gray-900">Upcoming Birthdays</h1>
                    </div>
                    <div className="mx-auto mt-8 grid max-w-md grid-cols-1 gap-6 sm:grid-cols-2 lg:max-w-none lg:grid-cols-3">
                        {upcomingBday.length > 0 ? upcomingBday.map((item) => (
                            <div key={item._id} className="bg-white p-6 rounded-lg shadow-md">
                                <img src={item.imagePath} alt={item.name} className="w-24 h-24 rounded-full mx-auto" />
                                <h2 className="mt-4 text-lg font-bold text-gray-900">{item.username}</h2>
                                <p className="mt-2 text-sm text-gray-500">{item.DOB.split("T")[0].split("-").reverse().join("-")}</p>
                            </div>
                        )) : (
                            <>
                                <div className="bg-white p-6 rounded-lg shadow-md hidden md:block">
                                    <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto"></div>
                                    <h2 className="mt-4 text-lg font-bold text-gray-900">xxx</h2>
                                    <p className="mt-2 text-sm text-gray-500">xxx</p>
                                </div>
                                <div className="bg-white p-6 rounded-lg shadow-md">
                                    <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto"></div>
                                    <h2 className="mt-4 text-lg font-bold text-gray-900 text-center text-red-500">No upcoming birthdays !</h2>
                                    <p className="mt-2 text-sm text-gray-500">xxx</p>
                                </div>
                                <div className="bg-white p-6 rounded-lg shadow-md">
                                    <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto"></div>
                                    <h2 className="mt-4 text-lg font-bold text-gray-900">xxx</h2>
                                    <p className="mt-2 text-sm text-gray-500">xxx</p>
                                </div>
                                <div className="bg-white p-6 rounded-lg shadow-md">
                                    <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto"></div>
                                    <h2 className="mt-4 text-lg font-bold text-gray-900">xxx</h2>
                                    <p className="mt-2 text-sm text-gray-500">xxx</p>
                                </div>
                                <div className="bg-white p-6 rounded-lg shadow-md">
                                    <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto"></div>
                                    <h2 className="mt-4 text-lg font-bold text-gray-900">xxx</h2>
                                    <p className="mt-2 text-sm text-gray-500">xxx</p>
                                </div>
                                <div className="bg-white p-6 rounded-lg shadow-md">
                                    <div className="w-24 h-24 bg-gray-200 rounded-full mx-auto"></div>
                                    <h2 className="mt-4 text-lg font-bold text-gray-900">xxx</h2>
                                    <p className="mt-2 text-sm text-gray-500">xxx</p>
                                </div>
                            </>
                        )}
                    </div>

                </div>
            </main>
        </div>
    );
}

export default UpcomingBday;